import { create } from "zustand";

export const useOrganisationsStore = create((set, get) => ({
  selectedOrganisations:
    JSON.parse(sessionStorage.getItem("LS_ORGANISATIONS_LIST")) || [],

  selectOrganisation: (selectedOrg) => {
    const { selectedOrganisations } = get();

    const isOrganisationSelected = selectedOrganisations.some(
      (org) => org.Organisation_ID === selectedOrg.Organisation_ID
    );

    if (isOrganisationSelected) return;

    sessionStorage.setItem(
      "LS_ORGANISATIONS_LIST",
      JSON.stringify([...selectedOrganisations, selectedOrg])
    );
    localStorage.setItem(
      "LS_ORGANISATIONS_LIST",
      JSON.stringify([...selectedOrganisations, selectedOrg])
    );

    set({
      selectedOrganisations: [...selectedOrganisations, selectedOrg],
    });
  },

  removeOrganisation: (orgId) => {
    const { selectedOrganisations } = get();

    const updatedSelectedOrganisations = selectedOrganisations.filter(
      (org) => org.Organisation_ID !== orgId
    );

    sessionStorage.setItem(
      "LS_ORGANISATIONS_LIST",
      JSON.stringify(updatedSelectedOrganisations)
    );
    localStorage.setItem(
      "LS_ORGANISATIONS_LIST",
      JSON.stringify(updatedSelectedOrganisations)
    );

    set({
      selectedOrganisations: updatedSelectedOrganisations,
    });
  },

  updateOrganisationAccountID: (organisationId, accountID) => {
    const { selectedOrganisations } = get();

    const updatedSelectedOrganisations = selectedOrganisations.map((org) =>
      org.Organisation_ID === organisationId
        ? { ...org, Organisation_Account_ID: accountID }
        : org
    );

    localStorage.setItem(
      "LS_ORGANISATIONS_LIST",
      JSON.stringify(updatedSelectedOrganisations)
    );

    set(() => ({
      selectedOrganisations: updatedSelectedOrganisations,
    }));
  },

  clearOrganisations: () => {
    sessionStorage.removeItem("LS_ORGANISATIONS_LIST");
    localStorage.removeItem("LS_ORGANISATIONS_LIST");

    set(() => ({
      selectedOrganisations: [],
    }));
  },
}));
